<div class="content-inner" [ngClass]="layoutService.expandedMenu ? 'expand' : ''">
    <div class="title-bar">
        <div class="container-fluid">
            <div class="row">
                <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
                    <div class="col-auto">
                        <h2 class="page-title">
                            <span (click)=backToManageUser()><img src="assets/ph-bhp-user/svg/back.svg"
                  class="svg"></span>{{'GENERAL.MY_TASK' | translate}}
                        </h2>
                    </div>
                    <div class="col-auto d-flex justify-content-md-end justify-content-sm-start">

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <form class="form-container" name="addUserFormGeneralInfo" [formGroup]="addUserFormGeneralInfo">
            <div class="my-4">
                <div class="row">
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                            <label for="name">{{ translationKeys.ProfileDetails.Name | translate }}</label>
                            <div>
                                {{ addUserFormGeneralInfo.get('name').value }}
                            </div>

                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                            <label for="isActive">{{ 'INSTITUTION_MANAGEMENT.STATUS' | translate }}</label>
                            <label class="switch mb-4 mt-2 d-block">
                <input class="form-control" type="checkbox" name="isActive" formControlName="isActive">
                <span class="slider round"></span>
                <span class="status active">{{ 'INSTITUTION_MANAGEMENT.ACTIVE' | translate }}</span>
                <span class="status inactive">{{ 'INSTITUTION_MANAGEMENT.IN_ACTIVE' | translate }}</span>
              </label>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                            <label for="email">{{ translationKeys.ProfileDetails.Email | translate }}</label>
                            <div>
                                {{ addUserFormGeneralInfo.get('email').value }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                            <label for="username">{{ translationKeys.Authorization.Username | translate }}</label>
                            <div>
                                {{ addUserFormGeneralInfo.get('username').value }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                            <label for="roleId">{{ translationKeys.ProfileDetails.Role | translate }}</label><span class="mandatory">*</span>
                            <select class="form-control" (ngModelChange)="onRoleChange($event)" name="roleId" [ngClass]="{'is-invalid':addUserFormGeneralInfo.get('roleId').errors && (addUserFormGeneralInfo.get('roleId').touched || addUserFormGeneralInfo.get('roleId').dirty || submitted)}"
                                formControlName="roleId" required>
                <option value="">{{ 'USER_MANAGEMENT.SELECT_ROLE' | translate }}</option>
                <option *ngFor='let role of roleDetails;let i = index' value="{{role.roleId}}">
                  {{role.roleName | translate}}
                </option>
              </select>
                            <div class="invalid-feedback" *ngIf="addUserFormGeneralInfo.get('roleId').errors && (addUserFormGeneralInfo.get('roleId').touched ||addUserFormGeneralInfo.get('roleId').dirty  || submitted)">
                                <span *ngIf="addUserFormGeneralInfo.get('roleId').errors.required">
                  {{ 'ERROR_MESSAGES.REQUIRED.ROLE' | translate }}
                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group" *ngIf="userDetails?.facilities.length > 0">
                            <label for="email">{{ 'GENERAL.REQUESTED_INSTITUTION' | translate }}</label>
                            <ul>
                                <li *ngFor="let facilite of userDetails?.facilities">
                                    {{ facilite?.facilityName }} ( {{ facilite?.facilitySAPId }} )
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group" *ngIf="addUserFormGeneralInfo.value.roleId != '' && addUserFormGeneralInfo.value.roleId != 1 && addUserFormGeneralInfo.value.roleId != 2 && institutionId == null">
                            <label *ngIf='addUserFormGeneralInfo.get("roleId").value == 4 || addUserFormGeneralInfo.get("roleId").value == 5'><label>{{ translationKeys.ProfileDetails.InstitutionName | translate }}</label><span class="mandatory">*</span></label>
                            <label *ngIf='addUserFormGeneralInfo.get("roleId").value == 3'><label>{{ 'INSTITUTION_MANAGEMENT.GROUP_NAME' | translate }}</label><span class="mandatory">*</span></label>
                            <div class="checkbox-container">
                                <div class="row mb-3">
                                    <div class="col-8">
                                        <input inputSanitizer class="form-control search-input" placeholder="{{ 'INSTITUTION_MANAGEMENT.SEARCH' | translate }}..." [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}">
                                    </div>
                                    <div class="col-4 p-0">
                                        <div class="mt-2" *ngIf="isMultiselect">
                                            <input type="checkbox" class="custom-control-input" id="selectAll" [ngModelOptions]="{standalone: true}" (change)="checkAll($event)" [(ngModel)]="selectins">
                                            <label for="selectAll">{{ 'INSTITUTION_MANAGEMENT.SELECT_ALL' | translate }}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="checkbox-container-list">
                                    <div class="mb-2" *ngFor='let institution of institutionsList | search:searchText'>
                                        <input type="checkbox" class="custom-control-input" (change)="checkValue(institution,$event)" *ngIf="isMultiselect" name="customCheck-{{institution.institutionID}}" id="customCheck-{{institution.institutionID}}" [(ngModel)]="institutionChecked[institution.institutionID]"
                                            [ngModelOptions]="{standalone: true}">

                                        <input type="radio" class="custom-control-input" (change)="checkValueradio(institution)" *ngIf="!isMultiselect" name="customCheck-{{institution.institutionID}}" id="customCheck-{{institution.institutionID}}" [(ngModel)]="institutionRadio" [value]="institution.institutionID"
                                            [ngModelOptions]="{standalone: true}">
                                        <label [ngClass]="(isMultiselect)?'':''" for="customCheck-{{institution.institutionID}}">{{institution.institutionName}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group" *ngIf="addUserFormGeneralInfo.value.roleId != '' && addUserFormGeneralInfo.value.roleId == 2">
                            <label *ngIf='addUserFormGeneralInfo.get("roleId").value == 2'><label>{{'GENERAL.COUNTRY_NAME' | translate }}</label><span class="mandatory">*</span></label>
                            <div class="checkbox-container">
                                <div class="row mb-3">
                                    <div class="col-8">
                                        <input inputSanitizer class="form-control search-input" placeholder="{{ 'INSTITUTION_MANAGEMENT.SEARCH' | translate }}..." [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}">
                                    </div>
                                </div>
                                <div class="checkbox-container-list">
                                    <div class="mb-2" *ngFor='let institution of countryData | search:searchText'>
                                        <input type="radio" class="custom-control-input" (change)="checkValuecountry(institution.countryID)" name="customCheck-{{institution.countryID}}" id="customCheck-{{institution.abbreviation}}" [(ngModel)]="countryRadio" [value]="institution.countryID"
                                            [ngModelOptions]="{standalone: true}">
                                        <label [ngClass]="(isMultiselect)?'':''" for="customCheck-{{institution.abbreviation}}">{{institution.countryName | labelSanitizer}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col my-4">
                        <button (click)="submitUser(addUserFormGeneralInfo.value)" class="btn btn-primary mr-4">{{ 'GENERAL.APPROVE' | translate }}</button>

                        <button (click)="cancelModal()" class="btn btn-cancel">{{ translationKeys.Authorization.Cancel | translate }}</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>


<!-- Modal - Add User Confirmation -->
<ng-template #cancelmodal>
    <div class="modal-header justify-content-between align-items-center mb-4">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body" data-simplebar>
        <p>{{'INSTITUTION_MANAGEMENT.INFORMATION_UNSAVED_CHANGES_LOST_AFTER_LEAVING' | translate}}</p>
    </div>
    <div class="modal-footer">
        <button (click)="modalRef.hide()" class="btn btn-cancel mr-4">{{ 'LAYOUT_MODULE.STAY' | translate }}</button>
        <button (click)="CancelUser();modalRef.hide()" class="btn btn-primary">{{ 'LAYOUT_MODULE.LEAVE' | translate }}</button>
    </div>
</ng-template>


<div class="side-appbar">
    <div class="container-fluid">
    </div>
</div>

<div id="page_overlay"></div>